// Single source of truth for the property-type label derived from the
// leading 1-2 digit code at the start of a property `title`.
// Example: "30 en Venta en CAMINO A LA VIÑA 4475" -> "Negocio/Patentes/Derechos de llave"
const CATEGORY_MAPPING = {
	"01": "Casa",
	"02": "Departamento",
	"03": "Oficina",
	"04": "Sitio",
	"05": "Local",
	"08": "Industrial",
	"09": "Agrícola",
	10: "Agrícola",
	13: "Agrícola",
	14: "Parcela",
	15: "Estacionamiento",
	16: "Terreno",
	17: "Bodega",
	30: "Negocio/Patentes/Derechos de llave",
	31: "Residencial/Pieza",
	32: "Hotel/Apart",
	33: "Complejo Turístico",
	34: "Departamento Amoblado",
};

const getCategoryByCode = (title) => {
	if (typeof title !== "string") {
		return "Categoría Desconocida";
	}

	const digits = title.match(/^\d{1,2}/);
	const foundCategory = digits ? digits[0].padStart(2, "0") : null;
	return CATEGORY_MAPPING[foundCategory] || "Categoría Desconocida";
};

export default getCategoryByCode;
